// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Discount Get
/**
 *
 * @param {{params: object, query: { paymentMethodId: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Discount.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Discount Create
/**
 *
 * @param {{ paymentMethodId: string, discountRate: number }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Discount.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Discount Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Discount.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Discount Update
/**
 *
 * @param {{ paymentMethodId: string, discountRate: number, isActive: boolean }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Discount.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Discount Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Discount.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
